export default "__VITE_ASSET__24612bc1__"